import { locateID } from "@xbs/lib-dom";
export function tagFilter(node, config) {
    const handleClick = (event) => {
        const tag = locateID(event.target, "data-tag");
        if (tag) {
            config.api.exec("set-filter", {
                match: tag,
                highlight: true,
                strict: true,
            });
            config.api.exec("set-state-search", {
                value: tag,
                open: true,
                focus: false,
                dropdown: {
                    open: false,
                },
            });
            event.stopPropagation();
        }
    };
    node.addEventListener("click", handleClick);
    return {
        destroy() {
            node.removeEventListener("click", handleClick);
        },
    };
}
//# sourceMappingURL=tagFilter.js.map